export const STOP_BULK_CREATION_CONFIRMATION_MODAL_CONFIG = [
  'Close Bulk Creation',
  'Are you sure you want to stop bulk creation process and close this window?',
  {
    submitText: 'Stop'
  }
]
